export const isStepSelected = (props, stepData) => {
    if (props.selectedSteps === undefined || !props.on ||
        props.showParameters ||
        stepData === undefined) {
        return false;
    }
    
    return props.selectedSteps.filter(
        step =>
            step !== undefined && step.id === stepData.id)
        .length > 0;
}

export const isStepSelection = (props) => {
    let selection = props.stepsSelection;
    if (selection === undefined) {
        return false;
    }
    
    let ret = props.stepNumber >= selection.fromStep && props.stepNumber <= selection.toStep;
    
    return ret;
}
